import React from 'react';

import { useWindowSize } from 'usehooks-ts';

const DualColumn: React.FunctionComponent<{
  children: JSX.Element | JSX.Element[];
}> = ({ children }) => {
  const windowSize = useWindowSize();

  return (
    <div
      className={` ${
        windowSize.width < 1550 ? '' : 'md:grid'
      }   flex flex-col lg:grid-cols-2 gap-2 lg:gap-3`}
    >
      {children}
    </div>
  );
};

export default DualColumn;
